"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHITE_5 = exports.GRAY_20 = exports.WHITE_10 = exports.WHITE_15 = exports.WHITE_30 = exports.WHITE_40 = exports.WHITE_50 = exports.WHITE_60 = exports.WHITE_70 = exports.WHITE_80 = exports.GREEN = exports.YELLOW = exports.ORANGE = exports.RED = exports.LIGHT_RED = exports.MAGIC_PURPLE_45 = exports.PURPLE = exports.LIGHT_PURPLE = exports.AQUA = exports.MAGIC_BLUE = exports.BLUE = exports.LIGHT_BLUE_80 = exports.LIGHT_GRAY_20 = exports.LIGHT_GRAY_25 = exports.LIGHT_GRAY_30 = exports.LIGHT_GRAY_50 = exports.LIGHT_GRAY_80 = exports.LIGHTER_GRAY_80 = exports.LIGHTER_GRAY_50 = exports.GRAY_10 = exports.GRAY_30 = exports.GRAY_40 = exports.GRAY_50 = exports.GRAY_60 = exports.GRAY_70 = exports.GRAY_80 = exports.GRAY_90 = exports.MAGIC_PURPLE = exports.LIGHT_BLACK = exports.LIGHT_BLUE = exports.LIGHTER_BLUE = exports.BLACK = exports.WHITE = exports.LIGHT_GRAY = exports.LIGHTER_GRAY = exports.GRAY = exports.HEX_OPACITY = exports.transparentize = exports.hslGradient = exports.hexToHSL = void 0;
exports.VIOLET_LIGHTER = exports.VIOLET_LIGHT = exports.VIOLET = exports.VIOLET_DARK = exports.DARK_BLUE = exports.LIGHTER_GRAY_20 = exports.PINK = exports.LIGHTER_PURPLE = exports.LIGHT_BLACK_80 = exports.BLACK_50 = exports.BLACK_80 = void 0;
// https://css-tricks.com/converting-color-spaces-in-javascript/
/**
 * Usage : hexToHSL("#123456")
 * @param H
 */
var hexToHSL = function (H) {
    // Convert hex to RGB first
    var r, g, b;
    var _a = __read(H, 7), second = _a[1], third = _a[2], fourth = _a[3], fifth = _a[4], sixth = _a[5], seventh = _a[6];
    if (H.length == 4) {
        r = Number("0x" + second + second);
        g = Number("0x" + third + third);
        b = Number("0x" + fourth + fourth);
    }
    else if (H.length == 7) {
        r = Number("0x" + second + third);
        g = Number("0x" + fourth + fifth);
        b = Number("0x" + sixth + seventh);
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin;
    var h = 0, s = 0, l = 0;
    if (cmax === r)
        h = ((g - b) / delta) % 6;
    else if (cmax === g)
        h = (b - r) / delta + 2;
    else
        h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0)
        h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return { h: h, s: s, l: l };
};
exports.hexToHSL = hexToHSL;
var hslGradient = function (steps, colors) {
    var parts = colors.length - 1;
    var gradient = new Array(steps);
    var gradientIndex = 0;
    var partSteps = Math.floor(steps / parts);
    var remainder = steps - partSteps * parts;
    for (var col = 0; col < parts; col++) {
        // get colors
        var c1 = colors[col];
        var c2 = colors[col + 1];
        // determine clockwise and counter-clockwise distance between hues
        var distCCW = c1.h >= c2.h ? c1.h - c2.h : 1 + c1.h - c2.h;
        var distCW = c1.h >= c2.h ? 1 + c2.h - c1.h : c2.h - c1.h;
        // ensure we get the right number of steps by adding remainder to final part
        if (col === parts - 1)
            partSteps += remainder;
        // make gradient for this part
        for (var step = 0; step < partSteps; step++) {
            var p = step / partSteps;
            // interpolate h, s, l
            var h = distCW <= distCCW ? c1.h + distCW * p : c1.h - distCCW * p;
            if (h < 0)
                h = 1 + h;
            if (h > 1)
                h = h - 1;
            var s = (1 - p) * c1.s + p * c2.s;
            var l = (1 - p) * c1.l + p * c2.l;
            // add to gradient array
            gradient[gradientIndex] = { h: h, s: s, l: l };
            gradientIndex++;
        }
    }
    return gradient;
};
exports.hslGradient = hslGradient;
var transparentize = function (color, transparency) {
    if (transparency === void 0) { transparency = 0; }
    var reg = /^#[0-9a-f]{6,8}$/i;
    if (!reg.test(color))
        return exports.WHITE;
    if (color.length === 9) {
        color = color.slice(0, -2);
    }
    var opacity = Math.round(Math.min(1 - transparency, 1) * 255);
    return color + opacity.toString(16).toUpperCase();
};
exports.transparentize = transparentize;
exports.HEX_OPACITY = {
    95: "F2",
    90: "E6",
    85: "D9",
    80: "CC",
    75: "BF",
    70: "B3",
    65: "A6",
    60: "99",
    55: "8C",
    50: "80",
    45: "73",
    40: "66",
    35: "59",
    30: "4D",
    25: "40",
    20: "33",
    15: "26",
    10: "1A",
    5: "0D",
};
var opacity = function (color, quantity) { return "".concat(color).concat(exports.HEX_OPACITY[quantity] || ""); };
exports.GRAY = "#3C3C3B";
exports.LIGHTER_GRAY = "#E4E4E4";
exports.LIGHT_GRAY = "#E2E2E2";
exports.WHITE = "#FFFFFF";
exports.BLACK = "#000000";
exports.LIGHTER_BLUE = "#EDF4FF";
exports.LIGHT_BLUE = "#588DE7";
exports.LIGHT_BLACK = "#131313";
exports.MAGIC_PURPLE = "#B39DDB";
var DesignColors = {
    GRAY_90: opacity(exports.GRAY, 90),
    GRAY_80: opacity(exports.GRAY, 80),
    GRAY_70: opacity(exports.GRAY, 70),
    GRAY_60: opacity(exports.GRAY, 60),
    GRAY_50: opacity(exports.GRAY, 50),
    GRAY_40: opacity(exports.GRAY, 40),
    GRAY_30: opacity(exports.GRAY, 30),
    GRAY_20: opacity(exports.GRAY, 20),
    GRAY_10: opacity(exports.GRAY, 10),
    LIGHTER_GRAY_20: opacity(exports.LIGHTER_GRAY, 20),
    LIGHTER_GRAY_50: opacity(exports.LIGHTER_GRAY, 50),
    LIGHTER_GRAY_80: opacity(exports.LIGHTER_GRAY, 80),
    LIGHT_GRAY_80: opacity(exports.LIGHT_GRAY, 80),
    LIGHT_GRAY_50: opacity(exports.LIGHT_GRAY, 50),
    LIGHT_GRAY_30: opacity(exports.LIGHT_GRAY, 30),
    LIGHT_GRAY_25: opacity(exports.LIGHT_GRAY, 25),
    LIGHT_GRAY_20: opacity(exports.LIGHT_GRAY, 20),
    LIGHT_BLUE_80: opacity(exports.LIGHT_BLUE, 80),
    BLUE: "#0051EE",
    MAGIC_BLUE: "#005AEE",
    DARK_BLUE: "#363670",
    AQUA: "#1ED2E3",
    PURPLE: "#8F4DEA",
    MAGIC_PURPLE_45: opacity(exports.MAGIC_PURPLE, 80),
    LIGHT_PURPLE: "#AC7BEF",
    LIGHTER_PURPLE: "#ACA0D3",
    PINK: "#F6B8D0",
    LIGHT_RED: "#FF4444",
    RED: "#FF0000",
    ORANGE: "#EE8245",
    YELLOW: "#FFC533",
    GREEN: "#08C191",
    WHITE_80: opacity(exports.WHITE, 80),
    WHITE_70: opacity(exports.WHITE, 70),
    WHITE_60: opacity(exports.WHITE, 60),
    WHITE_50: opacity(exports.WHITE, 50),
    WHITE_40: opacity(exports.WHITE, 40),
    WHITE_30: opacity(exports.WHITE, 30),
    WHITE_15: opacity(exports.WHITE, 15),
    WHITE_10: opacity(exports.WHITE, 10),
    WHITE_5: opacity(exports.WHITE, 5),
    BLACK_50: opacity(exports.WHITE, 50),
    BLACK_80: opacity(exports.WHITE, 80),
    LIGHT_BLACK_80: opacity(exports.LIGHT_BLACK, 80),
    VIOLET_DARK: "#4741BD",
    VIOLET: "#615AEE",
    VIOLET_LIGHT: "#8984F8",
    VIOLET_LIGHTER: "#B8B5F8",
};
exports.GRAY_90 = DesignColors.GRAY_90, exports.GRAY_80 = DesignColors.GRAY_80, exports.GRAY_70 = DesignColors.GRAY_70, exports.GRAY_60 = DesignColors.GRAY_60, exports.GRAY_50 = DesignColors.GRAY_50, exports.GRAY_40 = DesignColors.GRAY_40, exports.GRAY_30 = DesignColors.GRAY_30, exports.GRAY_10 = DesignColors.GRAY_10, exports.LIGHTER_GRAY_50 = DesignColors.LIGHTER_GRAY_50, exports.LIGHTER_GRAY_80 = DesignColors.LIGHTER_GRAY_80, exports.LIGHT_GRAY_80 = DesignColors.LIGHT_GRAY_80, exports.LIGHT_GRAY_50 = DesignColors.LIGHT_GRAY_50, exports.LIGHT_GRAY_30 = DesignColors.LIGHT_GRAY_30, exports.LIGHT_GRAY_25 = DesignColors.LIGHT_GRAY_25, exports.LIGHT_GRAY_20 = DesignColors.LIGHT_GRAY_20, exports.LIGHT_BLUE_80 = DesignColors.LIGHT_BLUE_80, exports.BLUE = DesignColors.BLUE, exports.MAGIC_BLUE = DesignColors.MAGIC_BLUE, exports.AQUA = DesignColors.AQUA, exports.LIGHT_PURPLE = DesignColors.LIGHT_PURPLE, exports.PURPLE = DesignColors.PURPLE, exports.MAGIC_PURPLE_45 = DesignColors.MAGIC_PURPLE_45, exports.LIGHT_RED = DesignColors.LIGHT_RED, exports.RED = DesignColors.RED, exports.ORANGE = DesignColors.ORANGE, exports.YELLOW = DesignColors.YELLOW, exports.GREEN = DesignColors.GREEN, exports.WHITE_80 = DesignColors.WHITE_80, exports.WHITE_70 = DesignColors.WHITE_70, exports.WHITE_60 = DesignColors.WHITE_60, exports.WHITE_50 = DesignColors.WHITE_50, exports.WHITE_40 = DesignColors.WHITE_40, exports.WHITE_30 = DesignColors.WHITE_30, exports.WHITE_15 = DesignColors.WHITE_15, exports.WHITE_10 = DesignColors.WHITE_10, exports.GRAY_20 = DesignColors.GRAY_20, exports.WHITE_5 = DesignColors.WHITE_5, exports.BLACK_80 = DesignColors.BLACK_80, exports.BLACK_50 = DesignColors.BLACK_50, exports.LIGHT_BLACK_80 = DesignColors.LIGHT_BLACK_80, exports.LIGHTER_PURPLE = DesignColors.LIGHTER_PURPLE, exports.PINK = DesignColors.PINK, exports.LIGHTER_GRAY_20 = DesignColors.LIGHTER_GRAY_20, exports.DARK_BLUE = DesignColors.DARK_BLUE, exports.VIOLET_DARK = DesignColors.VIOLET_DARK, exports.VIOLET = DesignColors.VIOLET, exports.VIOLET_LIGHT = DesignColors.VIOLET_LIGHT, exports.VIOLET_LIGHTER = DesignColors.VIOLET_LIGHTER;
